<template>
    <div :class="{hidden:this.$store.state.isLoaded===false}">
        <main-layout :ResizeCallback="resize">
          <div v-bind:style="{'height': this.PageHeight+'px'}">
            <div class="tabMenu">
                 <div style="width: 100%; margin: 0 auto;">
                      <template v-for="(item,index) in AuthData">
                        <a href="javascript:void(0)" @click='tabToggle(index)'>
                            <div class="tabItem" :class="{active:item.IsActive}">{{item.Name}}</div>
                        </a>
                      </template>
                 </div>
            </div>
            <div class="Content">
                <template v-for="(tabData,index) in AuthData">
                    <div :class="{hidden:!tabData.IsActive}">
                      <div class="title">
                        <img src="../assets/img/tableau reports.svg" class="iconMark"> REPORTS
                        <update-date :UpdateDateList="tabData.UpdateDateList"></update-date>
                      </div>
                      <div class="menu">
                          <template v-for="(category,index) in tabData.Categories">
                              <a :href="'#' + category.Category.UniqueCategoryName">
                                  <div :key="category.Category.CategoryId" :class="'tag Color'+ (index%8+1)" :style="(category.IsHidden? 'opacity:0.4': 'opacity:1')">
                                      <img src="../assets/img/marketing standard -W.svg" class="iconMark iconPadding" />
                                      <div class="tagContent">
                                          {{category.Category.CategoryName}}
                                      </div>
                                      <a href="javascript:void(0)" @click='tagToggle(category)'>
                                          <div :class="(category.IsHidden? 'tagHide': 'tagSign')" class="tagSign">
                                          </div>
                                      </a>
                                  </div>
                              </a>
                          </template>
                      </div>

                        <report-category v-for="(category,index) in tabData.Categories" :key="category.CategoryId" :category="category" :color="'Color'+ (index%8+1)">
                        </report-category>
                    </div>
                </template>
            </div>
          </div>
        </main-layout>
    </div>
</template>
<style>
.tabMenu {
  width: 100%;
  float: left;
  padding-left: 28px;
  /*margin-bottom: 25px;*/
  text-align: left;
  font-size: 14px;
  font-family: "HelveticaNeueBold";
  color: #4a4a4a;
  padding-top: 13px;
  /*box-shadow: 0px 0.5px 3px;*/
}

.tabItem {
  border-bottom-color: rgb(204, 204, 204);
  border-bottom-style: solid;
  border-bottom-width: 6px;
  box-sizing: border-box;
  color: #4a4a4a;
  cursor: auto;
  display: block;
  float: left;
  font-family: "HelveticaNeueBold";
  font-size: 15px;
  height: 44px;
  line-height: 22.5px;
  padding-bottom: 8px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 8px;
  width: 150px;
  text-align: center;
}

.tabItem.active {
  border-bottom-color: #0086e5;
}

.title {
  width: 94.5%;
  margin-top: 25px;
  margin-right: 33px;
  padding-bottom: 15px;
  float: left;
  text-align: left;
  font-size: 14px;
  font-family: "HelveticaNeueBold";
  color: #5c5c5c;
  border-bottom: 1px solid #000;
}

.tag {
  height: 40px;
  overflow: hidden;
  min-width: 210px;
  float: left;
  margin-top: 20px;
  margin-right: 20px;
  box-shadow: 0px 0.5px 3px #000;
  font-family: "HelveticaNeue";
  text-align: left;
  color: #fff;
}

.tag img {
  float: left;
}

.tag a:hover div {
  background-image: url("../assets/img/view-Hover.svg");
}

.tagContent {
  height: 30px;
  float: left;
  margin-top: 10px;
  margin-right: 15px;
}

.tagContent > a {
  color: white;
  text-decoration: none;
}

.tagSign {
  height: 100%;
  width: 40px;
  background-image: url("../assets/img/view.svg");
  background-repeat: no-repeat;
  background-size: 30px;
  background-color: #fff;
  background-position: center;
  float: right;
}

.tagHide {
  height: 100%;
  width: 40px;
  background-image: url("../assets/img/hide.svg");
  background-repeat: no-repeat;
  background-size: 30px;
  background-color: #fff;
  background-position: center;
  float: right;
}
</style>
<script>
import MainLayout from "../components/MainLayout.vue";
import ReportCategory from "../components/ReportCategory.vue";
import UpdateDate from "../components/UpdateDate.vue";

export default {
  data() {
    return {
      AuthData: this.$store.state.authData,
      PageHeight: this.getSize()
    };
  },
  mounted: function() {},
  created: function() {},
  components: {
    MainLayout,
    ReportCategory,
    UpdateDate
  },
  methods: {
    getSize: function() {
      return window.innerHeight - 165;
    },
    resize: function() {
      let height = this.getSize();
      this.PageHeight = height <= 350 ? 350 : height;
    },
    tabToggle: function(index) {
      this.$store.commit("switchTab", index);
    },
    tagToggle: function(category) {
      this.$store.commit("switchTag", category);
    }
  }
};
</script>



// WEBPACK FOOTER //
// Home.vue?2f584d9a